import { useAuth } from '@sp/data/auth';
import { useStreamChat } from '@sp/feature/stream-chat';
import { isNotNullish, usePrevious } from '@sp/util/helpers';
import { useEffect } from 'react';
import { CHAT_TEASERS_GLOBAL_MODEL } from './chat-teasers-global-model';
import { SELFPLUS_ADMINS_MODEL } from './selfplus-admins-model';

export function InitGlobalModels() {
  const { user } = useAuth();
  const previousUser = usePrevious(user);

  useStreamChat(user);

  useEffect(() => {
    const isUserChanged = !isNotNullish(previousUser) || user?.id !== previousUser.id;
    const isNeedLoad = isNotNullish(user) && isUserChanged;

    if (isNeedLoad) {
      CHAT_TEASERS_GLOBAL_MODEL.load();
      SELFPLUS_ADMINS_MODEL.load();
    }
  }, [previousUser, user]);

  return null;
}
